<template>
  <div class="approval-info-tabs">
    <div
      class="wizard wizard-4"
      id="kt_wizard_v4"
      data-wizard-state="step-first"
      data-wizard-clickable="true"
    >
      <div class="wizard-nav">
        <div class="wizard-steps">
          <div
            class="wizard-step"
            data-wizard-type="step"
            data-wizard-state="current"
          >
            <div class="wizard-wrapper">
              <div class="wizard-label">
                <div class="wizard-title">Thông tin</div>
              </div>
            </div>
          </div>
          
          <div
            class="wizard-step ml-1"
            data-wizard-type="step"
            v-show="approvalId"
          >
            <div class="wizard-wrapper">
              <div class="wizard-label">
                <div class="wizard-title">Tệp đính kèm</div>
              </div>
            </div>
          </div>
          
          <div
            class="wizard-step ml-1"
            data-wizard-type="step"
            v-show="approvalId"
          >
            <div class="wizard-wrapper">
              <div class="wizard-label">
                <div class="wizard-title">Lịch sử</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="card card-custom card-shadowless rounded-top-0">
        <div class="card-body p-0">
          <div class="row">
            <div class="col-xl-12">
              <div
                class="py-8 px-4 py-lg-15 px-lg-4 pb-5 full-width"
                data-wizard-type="step-content"
                data-wizard-state="current"
              >
                <slot name="information-tab"></slot>
              </div>
            </div>
            
            <div
              class="py-4 mb-5 full-width"
              data-wizard-type="step-content"
            >
              <slot name="attachments-tab"></slot>
            </div>
            
            <div
              class="col-xl-12 pb-5 full-width"
              data-wizard-type="step-content"
            >
              <slot name="history-tab"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KTWizard from '@/assets/js/components/wizard';
import KTUtil from '@/assets/js/components/util';

export default {
  name: 'ApprovalInfoTabs',
  props: {
    approvalId: {
      type: [String, Number],
      default: null
    },
    initialTab: {
      type: String,
      default: 'information',
      validator: value => ['information', 'attachments', 'history'].includes(value)
    }
  },
  data() {
    return {
      wizard: null
    };
  },
  mounted() {
    this.initWizard();
  },
  methods: {
    /**
     * Initialize the wizard component
     */
    initWizard() {
      // Determine the initial step based on props and route hash
      const hashName = this.$route.hash ? this.$route.hash.split('#')[1] : '';
      const startStep = hashName === 'attach' ? 2 : 
                        this.initialTab === 'attachments' ? 2 : 
                        this.initialTab === 'history' ? 3 : 1;
      
      // Initialize the wizard
      this.wizard = new KTWizard('kt_wizard_v4', {
        startStep: startStep,
        clickableSteps: true
      });
      
      // Add event listeners
      this.wizard.on('change', () => {
        setTimeout(() => {
          KTUtil.scrollTop();
        }, 500);
        
        // Emit tab change event
        const currentStep = this.wizard.getStep();
        let tabName = 'information';
        if (currentStep === 2) tabName = 'attachments';
        if (currentStep === 3) tabName = 'history';
        
        this.$emit('tab-change', tabName);
      });
    },
    
    /**
     * Go to a specific tab
     * @param {string} tabName - The name of the tab to go to
     */
    goToTab(tabName) {
      if (!this.wizard) return;
      
      let step = 1;
      if (tabName === 'attachments') step = 2;
      if (tabName === 'history') step = 3;
      
      this.wizard.goTo(step);
    }
  }
};
</script>

<style lang="scss" scoped>
.approval-info-tabs {
  .wizard-nav {
    background-color: #eef0f8;
  }
  
  .full-width {
    width: 100%;
  }
}
</style>
